import { Events } from '../../utils/servicesEvents'
import { Formatter } from './formatter'
import { AppDataRepo } from './repo'
import { AppData } from './appData'
import { Commons } from '@/utils/commons'

import { getProducts } from './networks/products/getProducts'
import { getOrders } from './networks/orders/getOrders'
import { getCustomers } from './networks/customers/getCustomers'
import { createProduct } from './networks/products/createProduct'
import { updateProduct } from './networks/products/updateProduct'
import { getPayments } from './networks/payments/getPayments'
import { getKycData } from './networks/kyc/getKycData'
import { saveAccountValidationKycData } from './networks/kyc/saveAccountValidationKycData'
import { deleteCustomer } from './networks/customers/deleteCustomer'
import { searchPayments } from './networks/payments/searchPayments'
import { getCategories } from './networks/products/getCategories'
import { sendHelpMessage } from './networks/chat/sendHelpMessage'
import { saveStorePreferences } from './networks/store/saveStorePreferences'
import { getBalance } from './networks/stats/getBalance'
import { getStoreData } from './networks/store/getStoreData'
import { publishProduct } from './networks/products/publishProduct'
import { unpublishProduct } from './networks/products/unpublishProduct'
import { deleteProduct } from './networks/products/deleteProduct'
import { launchSubscriptionPayment } from './networks/proSubscription/launchSubscriptionPayment'
import { updateOrderStatus } from './networks/orders/updateOrderStatus'
import { getSubscription } from './networks/proSubscription/getSubscription'
import { getStoreDetails } from './networks/store/getStoreDetails'
import { resolvePhoneNumber } from '../transaction/networks/resolvePhoneNumber'
import { getAppInfos } from './networks/appInfos/getAppInfos'
import { getStats } from './networks/stats/getStats'
import { createDeal } from './networks/deals/createDeal'
import { updateDeal } from './networks/deals/updateDeal'
import { deleteDeal } from './networks/deals/deleteDeal'
import { getDeals } from './networks/deals/getDeals'
import { getRiders } from './networks/riders/getRiders'
import { createRider } from './networks/riders/createRider'
import { deleteRider } from './networks/riders/deleteRider'
import { getWithdrawalAccounts } from './networks/withdrawal/getWithdrawalAccounts'
import { createWithdrawalAccount } from './networks/withdrawal/createWithdrawalAccount'
import { deleteWithdrawalAccount } from './networks/withdrawal/deleteWithdrawalAccount'
import { getWithdrawals } from './networks/withdrawal/getWithdrawals'
import { createWithdrawal } from './networks/withdrawal/createWithdrawal'
import { getStores } from './networks/store/getStores'
import { getStoresBalances } from './networks/stats/getStoresBalances'
import { getStoresStats } from './networks/stats/getStoresStats'
import { getStoreStats } from './networks/stats/getStoreStats'
import { getAllOrders } from './networks/orders/getAllOrders'
import { getAllPayments } from './networks/payments/getAllPayments'
import { getAllWithdrawals } from './networks/withdrawal/getAllWithdrawals'
import { getKycDocuments } from './networks/kyc/getKycDocuments'
import { updateKycStatus } from './networks/kyc/updateKycStatus'
import { getTeammates } from './networks/team/getTeammates'
import { createTeammate } from './networks/team/createTeammate'
import { updateTeammate } from './networks/team/updateTeammate'
import { deleteTeammate } from './networks/team/deleteTeammate'
import { updateAppInfos } from './networks/appInfos/updateAppInfos'
import { getPubs } from './networks/appInfos/getPubs'
import { updatePub } from './networks/appInfos/updatePub'
import { updateSubcategories } from './networks/products/updateSubcategories'
import { addCategory } from './networks/products/addCategory'
import { updateCategory } from './networks/products/updateCategory'
import { deleteCategory } from './networks/products/deleteCategory'
import { createChargeback } from './networks/payments/createChargeback'
import { getChargebacks } from './networks/payments/getChargebacks'
import { validateWithdrawal } from './networks/withdrawal/validateWithdrawal'
import { rejectWithdrawal } from './networks/withdrawal/rejectWithdrawal'
import { getFees } from './networks/fees/getFees'
import { saveFees } from './networks/fees/saveFees'

class AppDataController {
  static async downloadUserData() {
    // const userReference = await self.servicesVars.getUserReference()
    // if (!userReference) return
  }

  static async downloadRequirements() {
    // getStoreData('store_data_downloaded', 'failed_to_download_app_data')
    await getTeammates('teammates_downloaded', 'failed_to_download_app_data')
    AppDataController.downloadAllData()
  }

  static async downloadAllData() {
    // getKycData('app_data_downloaded', 'failed_to_download_app_data')
    // getBalance('app_data_downloaded', 'failed_to_download_app_data')
    getStats('app_data_downloaded', 'failed_to_download_app_data')
    getPubs('app_data_downloaded', 'failed_to_download_app_data')
    // getStores('stores_downloaded', 'failed_to_download_app_data')
    // getAllOrders('app_data_downloaded', 'failed_to_download_app_data')
    // getAllPayments('app_data_downloaded', 'failed_to_download_app_data')
    // getAllWithdrawals('app_data_downloaded', 'failed_to_download_app_data')
    // getStoreData('app_data_downloaded', 'failed_to_download_app_data')
    // getKycData('app_data_downloaded', 'failed_to_download_app_data')
    // getProducts('app_data_downloaded', 'failed_to_download_app_data')
    // getDeals('app_data_downloaded', 'failed_to_download_app_data')
    // getOrders('app_data_downloaded', 'failed_to_download_app_data')
    // getCustomers('app_data_downloaded', 'failed_to_download_app_data')
    // getRiders('app_data_downloaded', 'failed_to_download_app_data')
    // getPayments('app_data_downloaded', 'failed_to_download_app_data')
    getCategories('app_data_downloaded', 'failed_to_download_app_data')
    // getSubscription('app_data_downloaded', 'failed_to_download_app_data')
    getAppInfos('app_data_downloaded', 'failed_to_download_app_data')
    // getWithdrawalAccounts(
    //   'many_app_data_downloaded',
    //   'failed_to_download_app_data',
    // )
    // getWithdrawals('many_app_data_downloaded', 'failed_to_download_app_data')
  }

  static async initListeners() {
    listendDataCleaningRequest()
    listenAppDataRequest()
    listenAppDataDownloaded()
    listenAppDataSet()
  }

  static async getStoreData() {
    const db = await AppDataRepo.getDb()
    let data = await db.get('storeData')
    return data
  }
}

function listendDataCleaningRequest() {
  Events.handleEvent('clean_all_data_requested', async () => {
    const db = await AppDataRepo.getDb()
    await db.clean()
    Events.dispatchEvent('app_data_updated')
  })
}

function listenAppDataDownloaded() {
  // Events.handleEvent('stores_downloaded', async ({ data }) => {
  //   if (!data) return
  //   const db = await AppDataRepo.getDb()
  //   await db.save(data)
  //   Events.dispatchEvent('app_data_updated')
  //   getStoresBalances(
  //     data.metaData.stores,
  //     'app_data_downloaded',
  //     'failed_to_download_app_data',
  //   )
  //   getStoresStats(
  //     data.metaData.stores,
  //     'app_data_downloaded',
  //     'failed_to_download_app_data',
  //   )
  // })

  Events.handleEvent('teammates_downloaded', async ({ data }) => {
    if (!data) return
    const db = await AppDataRepo.getDb()
    await db.save(data)
    console.log(data)
    const userReference = await self.servicesVars.getUserReference()
    const matchingUser = data.metaData?.teammates.find(
      user => user.id == userReference,
    )
    if (!matchingUser) Events.dispatchEvent('logout_requested')
    console.log(matchingUser)
    const permissionsData = new AppData()
      .setContent('permissions')
      .setMetaData({ permissions: matchingUser.metadata.permissions })
    await db.save(permissionsData)

    Events.dispatchEvent('app_data_updated')
  })

  Events.handleEvent('app_data_downloaded', async ({ data }) => {
    const db = await AppDataRepo.getDb()
    await db.save(data)
    Events.dispatchEvent('app_data_updated')
  })

  Events.handleEvent('many_app_data_downloaded', async ({ data }) => {
    if (!data || !Array.isArray(data)) return
    const db = await AppDataRepo.getDb()
    await Promise.all(
      data.map(async singleData => {
        if (!singleData) return
        await db.save(data)
      }),
    )
    Events.dispatchEvent('app_data_updated')
  })

  Events.handleEvent('app_data_updated', async ({ data }) => {
    const userReference = await self.servicesVars.getUserReference()
    if (!userReference) return
    const db = await AppDataRepo.getDb()
    const accountLocked = await db.get('accountLocked')
    if (!accountLocked) return
    if (accountLocked && accountLocked?.metaData?.isLocked) {
      Events.dispatchEvent('toast_notification', {
        title: 'Votre compte est bloqué',
        body: "Votre compte a été bloqué. Contactez nous depuis notre site web kingrecharge.bet si vous pensez qu'ils s'agit d'une erreur",
      })
      Events.dispatchEvent('logout_requested')
    }
  })
}

function listenAppDataRequest() {
  const appDataKeys = [
    // 'stores',
    'appVersionData',
    'pubs',
    'appInfo',
    'contacts',
    'kycData',
    'categories',
    'subscription',
    'stats',
    'riders',
    'withdrawalAccountsBank',
    'withdrawalAccountsMomo',
    'storesStats',
    'storesBalances',
    'permissions',
    'teammates',
  ]
  appDataKeys.forEach(key => {
    Events.handleEvent(`request:${key}`, async ({ responseId }) => {
      const db = await AppDataRepo.getDb()
      const data = await db.get(key)
      Events.dispatchEvent(responseId, data)
    })
  })

  Events.handleEvent('request:locationData', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('locationData')
    if (!data) {
      const response = await downloadLocationData(
        'app_data_downloaded',
        'failed_to_download_app_data',
      )
      if (response.success) data = response.data
    }
    Events.dispatchEvent(responseId, data)
  })

  Events.handleEvent('request:stores', async ({ responseId, page, limit }) => {
    const res = await getStores(page, limit)
    if (res.statusCode !== 200) {
      Events.dispatchEvent(responseId, null)
      return
    }
    getStoresBalances(
      res.data.metaData.stores,
      'app_data_downloaded',
      'failed_to_download_app_data',
    )
    getStoresStats(
      res.data.metaData.stores,
      'app_data_downloaded',
      'failed_to_download_app_data',
    )
    Events.dispatchEvent(responseId, res.data)
  })

  Events.handleEvent(
    'request:withdrawalsByBank',
    async ({ responseId, page, limit }) => {
      const res = await getAllWithdrawals({ page, limit, type: 'bank' })
      if (res.statusCode !== 200) {
        Events.dispatchEvent(responseId, null)
        return
      }
      Events.dispatchEvent(responseId, res.data)
    },
  )

  Events.handleEvent(
    'request:withdrawalsByMomo',
    async ({ responseId, page, limit }) => {
      const res = await getAllWithdrawals({ page, limit, type: 'mobileMoney' })
      if (res.statusCode !== 200) {
        Events.dispatchEvent(responseId, null)
        return
      }
      Events.dispatchEvent(responseId, res.data)
    },
  )

  Events.handleEvent(
    'request:orders',
    async ({ responseId, page, status, limit }) => {
      const res = await getAllOrders({ page, limit, status })
      if (res.statusCode !== 200) {
        Events.dispatchEvent(responseId, null)
        return
      }
      Events.dispatchEvent(responseId, res.data)
    },
  )

  Events.handleEvent('request:kycDocuments', async ({ responseId }) => {
    const response = await getKycDocuments('')
    let data = null
    if (response.success) data = response.data
    Events.dispatchEvent(responseId, data)
  })

  Events.handleEvent(
    'request:storeDetails',
    async ({ responseId, storeId }) => {
      const res = await getStoreDetails(storeId)
      let result = {}
      if (res.statusCode === 200 && res.data) result = res.data
      Events.dispatchEvent(responseId, result)
    },
  )

  Events.handleEvent('request:products', async ({ responseId, storeId, search }) => {
    let res = await getProducts({storeId, search})
    let products = []
    if (res.statusCode == 200) {
      products = res.data?.metaData?.products || []
    }
    Events.dispatchEvent(responseId, products)
  })

  Events.handleEvent('request:deals', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('deals')
    Events.dispatchEvent(responseId, data?.metaData?.deals || [])
  })

  // Events.handleEvent('request:orders', async ({ responseId }) => {
  //   const db = await AppDataRepo.getDb()
  //   let data = await db.get('orders')
  //   Events.dispatchEvent(responseId, data?.metaData?.orders || null)
  // })

  Events.handleEvent('request:customers', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('customers')
    Events.dispatchEvent(responseId, data?.metaData?.customers || null)
  })

  Events.handleEvent('request:riders', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('riders')

    Events.dispatchEvent(responseId, data?.metaData?.riders || [])
  })

  Events.handleEvent('request:payments', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('payments')
    Events.dispatchEvent(responseId, data?.metaData?.payments || null)
  })

  Events.handleEvent('request:storeData', async ({ responseId, storeId }) => {
    const data = await getStoreData({ id: storeId })
    const store = data?.data?.metaData || null
    Events.dispatchEvent(responseId, store)
    if (!store) return
    getStoresBalances(
      [store],
      'app_data_downloaded',
      'failed_to_download_app_data',
    )
    getStoresStats(
      [store],
      'app_data_downloaded',
      'failed_to_download_app_data',
    )
  })

  Events.handleEvent('request:walletInfo', async ({ responseId, storeId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('storesBalances')
    if (!data) {
      Events.dispatchEvent(responseId, null)
      return
    }
    let res = {
      balance: data.metaData.totalBalance,
      pendingBalance: data.metaData.totalPendingBalance,
    }
    if (storeId)
      res = data.metaData.storesBalances[storeId] || {
        balance: 0,
        pendingBalance: 0,
      }

    Events.dispatchEvent(responseId, res)
  })

  Events.handleEvent('request:storeStats', async ({ responseId, storeId }) => {
    const res = await getStoreStats(storeId)
    let data = null
    if (res.statusCode == 200) data = res.data

    Events.dispatchEvent(responseId, data)
  })

  Events.handleEvent('request:fees', async ({ responseId, userId }) => {
    const res = await getFees(userId)
    let data = null
    if (res.statusCode == 200) data = res.data

    Events.dispatchEvent(responseId, data)
  })

  Events.handleEvent(
    'request:searchTransaction',
    async ({ responseId, searchText, page, limit, status }) => {
      const response = await searchPayments({ searchText, page, limit, status })
      if (!response.success) {
        Events.dispatchEvent(responseId, null)
        return
      }
      Events.dispatchEvent(responseId, response.data)
    },
  )

  Events.handleEvent('request:checkoutData', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('checkoutData')
    if (!data) {
      data = new AppData().setContent('checkoutData').setMetaData({
        totalAmount: 0,
        totalDichesAmount: 0,
        deliveryAmount: 0,
        fees: 0,
        orderedDiches: [],
      })
    }
    Events.dispatchEvent(responseId, Commons.changeToJson(data))
  })

  Events.handleEvent('new_checkout_data_available', async data => {
    const db = await AppDataRepo.getDb()
    const dataToSave = new AppData()
      .setContent('checkoutData')
      .setMetaData(data)
    await db.save(dataToSave)
    Events.dispatchEvent('checkout_updated')
  })

  Events.handleEvent('request:resolvePhoneNumber', async data => {
    const { responseId } = data
    resolvePhoneNumber(data, responseId, responseId)
  })
}

function listenAppDataSet() {
  Events.handleEvent('new_teammate_ready_to_be_added', data => {
    createTeammate(data, 'teammate_created', 'failed_to_create_teammate')
  })
  Events.handleEvent('teammate_created', () => {
    getTeammates('teammates_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('teammate_ready_to_be_updated', data => {
    updateTeammate(data, 'teammate_updated', 'failed_to_update_teammate')
  })
  Events.handleEvent('teammate_deletion_requested', ({ id }) => {
    deleteTeammate({ id }, 'teammate_deleted', 'failed_to_delete_teammate')
  })
  Events.handleEvent('teammate_updated', () => {
    getTeammates('teammates_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('teammate_deleted', () => {
    getTeammates('teammates_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('new_deal_ready_to_be_added', data => {
    createDeal(data, 'deal_created', 'failed_to_create_deal')
  })
  Events.handleEvent('deal_ready_to_be_updated', data => {
    updateDeal(data, 'deal_updated', 'failed_to_update_deal')
  })
  Events.handleEvent('deal_deletion_requested', ({ id }) => {
    deleteDeal(id, 'deal_deleted', 'failed_to_delete_deal')
  })
  Events.handleEvent('deal_created', () => {
    getDeals('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('deal_updated', () => {
    getDeals('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('deal_deleted', () => {
    getDeals('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('app_info_update_available', async data => {
    const db = await AppDataRepo.getDb()
    let appInfo = await db.get('appInfo')
    if (!appInfo || !appInfo.metaData.sizes) {
      Events.dispatchEvent('failed_to_save_app_info')
      return
    }
    const newData = {
      ...appInfo.metaData,
      ...data,
    }
    updateAppInfos(newData, 'app_info_saved', 'failed_to_save_app_info')
  })
  Events.handleEvent('app_info_saved', () => {
    getAppInfos('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('pub_update_available', async data => {
    updatePub(data, 'pubs_saved', 'failed_to_save_pubs')
  })
  Events.handleEvent('pubs_saved', () => {
    getPubs('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('new_category_available', async data => {
    addCategory(data, 'categories_saved', 'failed_to_save_categories')
  })
  Events.handleEvent('category_update_available', async data => {
    updateCategory(data, 'categories_saved', 'failed_to_save_categories')
  })
  Events.handleEvent('category_deletion_requested', async data => {
    deleteCategory(data, 'categories_saved', 'failed_to_save_categories')
  })
  Events.handleEvent('subcategories_update_available', async data => {
    updateSubcategories(data, 'categories_saved', 'failed_to_save_categories')
  })
  Events.handleEvent('categories_saved', () => {
    getCategories('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('new_withdrawal_account_ready_to_be_added', data => {
    createWithdrawalAccount(
      data,
      'withdrawal_account_created',
      'failed_to_create_withdrawal_account',
    )
  })
  Events.handleEvent('withdrawal_account_deletion_requested', ({ id }) => {
    deleteWithdrawalAccount(
      id,
      'withdrawal_account_deleted',
      'failed_to_delete_withdrawal_account',
    )
  })
  Events.handleEvent('account_validation_info_available', validationData => {
    saveAccountValidationKycData(
      'account_validation_info_saved',
      'account_validation_info_saving_failed',
      validationData,
    )
  })
  Events.handleEvent('account_validation_info_saved', () => {
    getKycData('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('match_filters_updated', async filters => {
    const db = await AppDataRepo.getDb()
    const filtersData = Formatter.formatFiltersSelected(filters)
    await db.save(filtersData)
    AppDataController.filterMatches()
  })
  Events.handleEvent('customer_deletion_requested', async ({ customer }) => {
    deleteCustomer(
      customer.id,
      'customer_deletion_done',
      'customer_deletion_failed',
    )
  })

  Events.handleEvent('customer_deletion_done', () => {
    console.log('customer deleted')
    getCustomers('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('help_message_request_filled', data => {
    console.log('will send help message')
    sendHelpMessage(data, 'help_message_sent', 'help_message_not_sent')
  })

  Events.handleEvent('store_preferences_setted', data => {
    console.log('will save store preferences')
    saveStorePreferences(data, 'store_data_saved', 'failed_to_save_store_data')
  })

  Events.handleEvent('store_data_saved', () => {
    getStoreData('store_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('pro_subscription_payment_required', data => {
    launchSubscriptionPayment(
      data,
      'pro_subscription_payment_launched',
      'failed_to_launch_pro_subscription_payment',
    )
  })

  Events.handleEvent('kyc_document_status_updated', data => {
    updateKycStatus(data, 'kyc_status_updated', 'failed_to_update_kyc_status')
  })

  // Events.handleEvent('kyc_status_updated', () => {
  //   getKycDocuments('app_data_downloaded', 'failed_to_download_app_data')
  // })

  Events.handleEvent('subscription_payment_done', () => {
    getSubscription('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('chargeback_creation_requested', data => {
    createChargeback(data, 'chargeback_created', 'failed_to_create_chargeback')
  })

  Events.handleEvent(
    'request:chargebacks',
    async ({ responseId, page, limit }) => {
      const response = await getChargebacks({ page, limit })
      Events.dispatchEvent(responseId, response.data || null)
    },
  )

  Events.handleEvent('withdrawal_validation_requested', data => {
    validateWithdrawal(
      data,
      'withdrawal_validated',
      'failed_to_validate_withdrawal',
    )
  })

  Events.handleEvent('withdrawal_rejection_requested', data => {
    rejectWithdrawal(data, 'withdrawal_rejected', 'failed_to_reject_withdrawal')
  })

  Events.handleEvent('fees_update_available', data => {
    saveFees(data, 'fees_updated', 'failed_to_update_fees')
  })

  Events.handleEvent('product_publish_requested', async ({ id }) => {
    publishProduct(id, 'product_published', 'failed_to_publish_product')
  })

  Events.handleEvent('product_unpublish_requested', ({ id }) => {
    unpublishProduct(id, 'product_unpublished', 'failed_to_unpublish_product')
  })
}

export { AppDataController }
